<ng-container [ngSwitch]="mode">
	<ng-container *ngSwitchCase="'checkout'">
		<div class="details-section mt-2">
			<ng-container *ngIf="item.type === CartItemType.AD_UNIT">
				<ng-container *ngFor="let layer of item.metadata?.layers | flattenLayers">
					<ng-container *ngIf="layer.type !== LayerType.TEXT">
						<div class="section-title mt-3" [ngSwitch]="layer.type">
							<ng-container *ngSwitchCase="LayerType.IMAGE" i18n="Layer Type@@cartListItemRowImageLayerTitle"
								>Image layer:
							</ng-container>
							<ng-container *ngSwitchCase="LayerType.VIDEO" i18n="Layer Type@@cartListItemRowVideoLayerTitle"
								>Video layer:
							</ng-container>
							<ng-container *ngSwitchCase="LayerType.AUDIO" i18n="Layer Type@@cartListItemRowAudioLayerTitle"
								>Audio layer:
							</ng-container>
							<ng-container *ngIf="layer.label">{{ layer.label }}</ng-container>
						</div>
					</ng-container>

					<table class="details-table basic" [ngSwitch]="layer.type">
						<ng-container *ngSwitchCase="LayerType.TEXT">
							<tr *ngIf="layer.text?.content">
								<td class="label">{{ layer.label }}</td>
								<td class="value"><p [innerHTML]="layer.text?.content"></p></td>
							</tr>
						</ng-container>

						<ng-container *ngSwitchCase="LayerType.IMAGE">
							<tr *ngIf="layer.image?.assetPath">
								<td class="label" i18n="Path Label@@cartListItemRowPathLabel">Path</td>
								<td class="value"><p [innerHTML]="layer.image.assetPath"></p></td>
							</tr>
							<tr *ngIf="layer.image?.dimensions?.width && layer.image?.dimensions?.height">
								<td class="label" i18n="Dimensions Label@@cartListItemRowDimensionsLabel">Dimensions</td>
								<td class="value">
									<p [innerHTML]="layer.image.dimensions.width + 'x' + layer.image.dimensions.height"></p>
								</td>
							</tr>
						</ng-container>

						<ng-container *ngSwitchCase="LayerType.VIDEO">
							<tr *ngIf="layer.video?.assetPath">
								<td class="label" i18n="Path Label@@cartListItemRowPathLabel">Path</td>
								<td class="value"><p [innerHTML]="layer.video.assetPath"></p></td>
							</tr>
							<tr *ngIf="layer.video?.dimensions?.width && layer.video?.dimensions?.height">
								<td class="label" i18n="Dimensions Label@@cartListItemRowDimensionsLabel">Dimensions</td>
								<td class="value">
									<p [innerHTML]="layer.video.dimensions.width + 'x' + layer.video.dimensions.height"></p>
								</td>
							</tr>
						</ng-container>

						<ng-container *ngSwitchCase="LayerType.AUDIO">
							<tr *ngIf="layer.video?.assetPath">
								<td class="label" i18n="Path Label@@cartListItemRowPathLabel">Path</td>
								<td class="value"><p [innerHTML]="layer.video.assetPath"></p></td>
							</tr>
							<tr *ngIf="layer.video?.dimensions?.width && layer.video?.dimensions?.height">
								<td class="label" i18n="Dimensions Label@@cartListItemRowDimensionsLabel">Dimensions</td>
								<td class="value">
									<p [innerHTML]="layer.video.dimensions.width + 'x' + layer.video.dimensions.height"></p>
								</td>
							</tr>
						</ng-container>
					</table>
				</ng-container>
			</ng-container>

			<ng-container *ngIf="item.type === CartItemType.VIDEO">
				<!-- In the parent component due to limitations when splitting tab-group and tab into different components -->
			</ng-container>
		</div>
	</ng-container>

	<div class="flex list-item" *ngSwitchDefault>
		<div class="left cart-item-hover">
			<a (click)="goToItem.emit(item)">
				<ng-container *ngIf="item.name">
					<strong
						*localVar="item.name || item.itemData.name || item.metadata.name as name"
						[innerHTML]="(
							useItemTranslation
								? (name | getLocale: item?.locale?.name)
								: name
							) | highlightMatch:highlightQuery"
					></strong>

					<ng-container *ngIf="item.metadata.templateCreativeUnit as templateCreativeUnit">
						<span class="size"> -</span>
						<span class="size">{{ templateCreativeUnit | getLocale : item.locale?.templateCreateUnit?.name }}</span>
					</ng-container>

					<ng-container *ngIf="item | dimension as itemDimension">
						<span class="size">-</span>
						<span class="size"
						>{{ itemDimension?.width + 'x' || '' }}{{ itemDimension?.height || ''
						}}{{ itemDimension?.defaultDisplayUnit || '' }}</span>
					</ng-container>
				</ng-container>
				<ng-container *ngIf="item.metadata.videoFormatText || item.metadata.videoResolution">
					<span class="size"> -</span>
					<strong class="size">{{ item.metadata.videoFormatText }}</strong>
					<span *ngIf="item.metadata.videoResolution as videoResolution" class="size">{{
						videoResolution
					}}</span>
				</ng-container>
			</a>
		</div>
		<div class="right flex align-center">
			<ng-container [ngSwitch]="mode">
				<ng-container *ngSwitchCase="'list'">
					<div class="actions">
						<mat-icon
							inline
							class="cursor-pointer"
							color="warn"
							*ngIf="showDelete"
							(click)="$event.stopPropagation(); deleteItem.emit(item)"
							>delete</mat-icon
						>

						<ng-container *ngIf="item | canBeApproved; else inProgressTemplate">
							<app-item-review-status
									*ngIf="showReview"
									[item]="item"
									[actionInProgress]="actionInProgress"
									(onItemActionEmitter)="onItemAction($event)">
							</app-item-review-status>
						</ng-container>
					</div>
				</ng-container>

				<ng-container *ngSwitchCase="'post-checkout'">
					<!-- Post-Checkout Mode -->
				</ng-container>
			</ng-container>
		</div>
	</div>
</ng-container>

<ng-template #inProgressTemplate>
	<span class="progress-text" i18n="In Progress Text@@cartListItemRowInProgressText">In Progress</span>
</ng-template>
